import Loading from "../../views/blocks/Loading"

export default Vue => {
  Vue.component("Loading", Loading)
}
